module.exports = __webpack_public_path__ + "img/three-stones.9ccb2024.jpeg";